import { Box, Typography } from "@mui/material";

export default function SingleProj({ imgSrc, projectName, url, description, id }) {
  return (
    <Box className="project-box project-chunk" id={id}>
      <img src={imgSrc} alt="" />
      <Box className="layer">
        <Box component={"a"} href={url} target="_blank" className="chunk-link">
          <Typography variant="h5" className="chunk-name">
            {projectName}
          </Typography>
          <box-icon className="cursor-pointer" color="#0070E0" name="link-external"></box-icon>
        </Box>
        <Typography variant="subtitle1" className="!leading-[1.2] text-white">
          {description}
        </Typography>
      </Box>
    </Box>
  );
}
